import React, { useState } from 'react';
import { User } from '../types';

interface TrialBannerProps {
  user: User;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ user }) => {
  const [showPricing, setShowPricing] = useState(false);
  
  // Only show banner for free plan users
  if (user.plan !== 'free') {
    return null;
  }
  
  const handleUpgradeClick = () => {
    setShowPricing(true);
  };

  if (showPricing) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg">
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-medium text-gray-900">
              Upgrade Your Account
            </h2>
            <button
              onClick={() => setShowPricing(false)}
              className="text-gray-400 hover:text-gray-500"
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <div className="p-6">
          <button
            onClick={async () => {
              try {
                const paymentLink = await fetch('/api/billing/payment-link', {
                  method: 'GET',
                  credentials: 'include'
                });
                const data = await paymentLink.json();
                if (data.url) {
                  window.location.href = data.url;
                }
              } catch (error) {
                console.error('Error getting payment link:', error);
                alert('Sorry, there was an error starting the checkout process. Please try again.');
              }
            }}
            className="w-full bg-orange-600 text-white px-6 py-3 rounded-md font-medium hover:bg-orange-700 transition duration-200"
          >
            Upgrade to Professional - £12.50/month
          </button>
          <p className="text-xs text-gray-500 text-center mt-3">
            + VAT where applicable • Secure payment via Stripe • Cancel anytime
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 border-l-4 border-blue-700">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-200" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-white font-medium">
              You're on the Free Plan (1 GSC Property Limit)
            </p>
            <p className="text-blue-100 text-sm">
              Upgrade to Pro for unlimited properties, keyword tracking, AI content briefs, and full 16-month history
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            onClick={handleUpgradeClick}
            className="bg-white text-blue-600 hover:text-blue-500 px-4 py-2 rounded-md text-sm font-medium transition duration-200 shadow-sm hover:shadow-md"
          >
            Upgrade to Pro
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;